export default {
  '_b._qhyy': 'Taal wijzigen',

  '_a._jzz': 'Laden...',
  '_a._jzgd': 'Meer laden',
  '_a._wct': 'Welkom bij',
  '_a._gd': 'Meer',
  '_a._bf': 'Afspelen',
  '_a._bcz': 'Opslaan...',
  '_a._sctp': 'Afbeelding uploaden',

  '_dl._qssyx': 'Voer uw e-mailadres in',
  '_dl._qssmm': 'Voer uw wachtwoord in',
  '_dl._ann': 'Inloggen',
  '_dl._hmyzh': 'Hebt u geen account?',
  '_dl._qzc': 'Registreren',
  '_dl._yzhl': 'Hebt u al een account?',
  '_dl._qdl': 'Inloggen',
  '_dl._srqrmm': 'Bevestig uw wachtwoord',
  '_dl._sryqm': 'Voer uitnodigingscode in',
  '_dl._sryzm': 'Voer verificatiecode in',
  '_dl._ljzc': 'Nu registreren',
  '_dl._zcbsty': 'Registratie betekent akkoord met het',
  '_dl._yszc': 'Privacybeleid',
  '_dl._lcmmbyy': 'Wachtwoorden komen niet overeen',

  '_yzm._fsyzm': 'Verificatiecode verzenden',
  '_yzm._cxfs': '({time}) Opnieuw verzenden',
  '_yzm._fsz': 'Wordt verzonden...',
  '_yzm._fscg': 'Succesvol verzonden',

  '_h._zrm': 'Meest populair',
  '_h._zxd': 'Nieuwste',
  '_h._phb': 'Ranking',
  '_h._qz': 'Achtergronden',
  '_h._ssww': 'Zoeken',
  '_h._lsjl': 'Geschiedenis',
  '_h._gd': 'Meer',
  '_h._dl': 'Inloggen',
  '_h._ye': 'Saldo',
  '_h._dj': 'Bevroren',
  '_h._ybp': 'Dashboard',
  '_h._wdqb': 'Mijn portemonnee',
  '_h._scjl': 'Favorieten',
  '_h._xxzx': 'Berichtencentrum',
  '_h._fxhy': 'Delen met vrienden',
  '_h._bzzx': 'Helpcentrum',
  '_h._ggtf': 'Advertentieplaatsing',
  '_h._bqtz': 'Auteursrechteninvestering',
  '_h._sz': 'Instellingen',

  '_sy._jx': 'Uitgelicht',
  '_sy._xpfb': 'Nieuwe releases',
  '_sy._gdsp': "Meer video's",

  '_qz._jbqz': 'Verfijnde achtergrondcollectie',
  '_qz._ssqz': 'Achtergrond zoeken',
  '_qz._qb': 'Alle',
  '_qz._zrfg': 'Natuurlijke landschappen',
  '_qz._cxys': 'Abstracte kunst',
  '_qz._csjz': 'Stedelijke architectuur',
  '_qz._dmyx': 'Anime & games',
  '_qz._yzxk': 'Kosmos & sterren',
  '_qz._yl': 'Voorbeeld',
  '_qz._xzqz': 'Achtergrond downloaden',
  '_qz._fbl': 'Resolutie',
  '_qz._fl': 'Categorie',
  '_qz._jzz': 'Laden',
  '_qz._myzdpp': 'Geen passende achtergronden gevonden',

  '_sp._xyjscl': 'Ontgrendelen vereist om te bekijken',
  '_sp._cz': 'Opwaarderen',
  '_sp._jsqj': 'Ontgrendel alle afleveringen',
  '_sp._jsbj': 'Ontgrendel deze aflevering',
  '_sp._sc': 'Favoriet',
  '_sp._fx': 'Delen',
  '_sp._jsqjjs': 'Betaling van {a} bevestigen om alle afleveringen te ontgrendelen?',
  '_sp._jsbjjs': 'Betaling van {a} bevestigen om deze aflevering te ontgrendelen?',
  '_sp._zfz': 'Betaling verwerken...',
  '_sp._qrzf': 'Betaling bevestigen',
  '_sp._qx': 'Annuleren',

  '_qz._smrc': 'Bergzonsopgang',
  '_qz._cxjh': 'Abstracte geometrie',
  '_qz._dsyj': 'Stadsnachtlandschap',
  '_qz._dmfj': 'Anime landschap',
  '_qz._hhxk': 'Uitgestrekte sterrenhemel',
  '_qz._slmw': 'Bosmist',
  '_qz._scld': 'Kleurstroom',
  '_qz._xdjz': 'Moderne architectuur',

  '_qb._cbjl': 'Stortingsgeschiedenis',
  '_qb._jyjl': 'Transactiegeschiedenis',
  '_qb._bddz': 'Gekoppelde adressen',
  '_qb._txjl': 'Opnamegeschiedenis',

  '_m._tcdl': 'Uitloggen',
  '_m._cb': 'Storten',
  '_m._tb': 'Opnemen',

  '_cb._ssdz': 'Zoek valuta of adres',
  '_cb._bz': 'Valuta',
  '_cb._je': 'Bedrag',
  '_cb._dz': 'Adres',
  '_cb._sj': 'Tijd',
  '_cb._cz': 'Actie',
  '_cb._zwjl': 'Nog geen transacties',
  '_cb._dny': 'Pagina {a} van {b}',
  '_cb._jyxq': 'Transactiedetails',
  '_cb._jydz': 'Transactieadres',
  '_cb._zt': 'Status',
  '_cb._yqr': 'Bevestigd',
  '_cb._qb': 'Alle',
  '_cb._jt': 'Vandaag',
  '_cb._j7t': 'Laatste 7 dagen',
  '_cb._j30t': 'Laatste 30 dagen',
  '_cb._zw': 'Geen',
  '_cb._fzcg': 'Adres gekopieerd naar klembord',

  '_jyjl._ssdz': 'Zoek valuta of adres',
  '_jyjl._lx': 'Type',
  '_jyjl._je': 'Bedrag',
  '_jyjl._ye': 'Saldo',
  '_jyjl._dj': 'Bevroren',
  '_jyjl._sj': 'Tijd',
  '_jyjl._cz': 'Actie',
  '_jyjl._zwjyjl': 'Nog geen transacties',
  '_jyjl._czsx': 'Filter resetten',
  '_jyjl._dny': 'Pagina {a} van {b}',
  '_jyjl._jyxq': 'Transactiedetails',
  '_jyjl._jylx': 'Transactietype',
  '_jyjl._jyje': 'Transactiebedrag',
  '_jyjl._jyhye': 'Saldo na transactie',
  '_jyjl._djye': 'Bevroren bedrag',
  '_jyjl._jysj': 'Transactietijd',
  '_jyjl._jyzt': 'Transactiestatus',
  '_jyjl._ywc': 'Voltooid',
  '_jyjl._qb': 'Alle',
  '_jyjl._jt': 'Vandaag',
  '_jyjl._j7t': 'Laatste 7 dagen',
  '_jyjl._j30t': 'Laatste 30 dagen',

  '_jyjl._tp1': 'Storting',
  '_jyjl._tp2': 'Opname',
  '_jyjl._tp3': 'Betaling',
  '_jyjl._tp4': 'Storting',
  '_jyjl._tp5': 'Bevriezen',
  '_jyjl._tp6': 'Inkomsten',
  '_jyjl._tp7': 'Uitnodigingsbeloning',
  '_jyjl._tp8': 'Loginbeloning',
  '_jyjl._tp9': 'Promotie-inkomsten',
  '_jyjl._tp10': 'Videobeloning',
  '_jyjl._tp11': 'Registratiebonus',
  '_jyjl._tp12': 'Intrekking afgewezen',
  '_jyjl._tp13': 'Bericht rood pakket',

  '_jyjl._tp14': 'Interne overdracht',

  '_cb._shz': 'In behandeling',
  '_cb._yyg': 'Goedgekeurd',
  '_cb._ybh': 'Afgewezen',

  '_bddz._tjdz': 'Adres toevoegen',
  '_bddz._ssdz': 'Zoek adres',
  '_bddz._bz': 'Valuta',
  '_bddz._dz': 'Adres',
  '_bddz._sysj': 'Laatst gebruikt',
  '_bddz._cz': 'Actie',
  '_bddz._zwjl': 'Nog geen adressen',
  '_bddz._dny': 'Pagina {a} van {b}',
  '_bddz._dzewm': 'QR-code adres',
  '_bddz._fzdz': 'Adres kopiëren',
  '_bddz._dzxq': 'Adresdetails',
  '_bddz._wl': 'Netwerk',
  '_bddz._tjsj': 'Toegevoegde tijd',
  '_bddz._bzwa': 'Opmerking',
  '_bddz._ntq': '{a} dagen geleden',
  '_bddz._nxsq': '{a} uur geleden',
  '_bddz._nfzq': '{a} minuten geleden',
  '_bddz._ngg': 'Zojuist',
  '_bddz._dzyfz': 'Adres gekopieerd naar klembord',
  '_bddz._scqr': 'Verwijderingsbevestiging',
  '_bddz._scqrdz': 'Dit adres verwijderen?',
  '_bddz._qr': 'Bevestigen',
  '_bddz._qx': 'Annuleren',
  '_bddz._scdzcg': 'Adres succesvol verwijderd',

  '_txjl._ztsx': 'Statusfilter',
  '_txjl._qbzt': 'Alle statussen',
  '_txjl._shz': 'In behandeling',
  '_txjl._ytg': 'Goedgekeurd',
  '_txjl._yjj': 'Afgewezen',
  '_txjl._ssdz': 'Zoek adres of bedrag',
  '_txjl._bz': 'Valuta',
  '_txjl._je': 'Bedrag',
  '_txjl._dz': 'Adres',
  '_txjl._zt': 'Status',
  '_txjl._sj': 'Tijd',
  '_txjl._cz': 'Actie',
  '_txjl._zwjl': 'Nog geen transacties',
  '_txjl._czsx': 'Filter resetten',
  '_txjl._dny': 'Pagina {a} van {b}',
  '_txjl._jyxq': 'Transactiedetails',
  '_txjl._skdz': 'Ontvangstadres',
  '_txjl._jysj': 'Transactietijd',
  '_txjl._jyzt': 'Transactiestatus',
  '_txjl._fzdz': 'Adres gekopieerd naar klembord',

  '_cbsq._bz': 'Valuta',
  '_cbsq._wl': 'Netwerk',
  '_cbsq._erwm': 'QR-code',
  '_cbsq._fzdz': 'Adres kopiëren',

  '_txsq._bz': 'Valuta',
  '_txsq._wl': 'Netwerk',
  '_txsq._ye': 'Saldo',
  '_txsq._sxf': 'Vergoeding',
  '_txsq._zxtx': 'Minimale opname',
  '_txsq._txdz': 'Opnameadres',
  '_txsq._qxztxdz': 'Selecteer opnameadres',
  '_txsq._txje': 'Opnamebedrag',
  '_txsq._qsrtxje': 'Voer opnamebedrag in',
  '_txsq._yxyzm': 'E-mailverificatiecode',
  '_txsq._qsryxyzm': 'Voer verificatiecode in',
  '_txsq._ljtx': 'Nu opnemen',

  '_jl._wxhd': 'Mijn favorieten',
  '_jl._lsjl': 'Geschiedenis',

  '_xx._bt': 'Berichtencentrum',
  '_xx._wjl': 'Geen gegevens',
  '_xx._zsmyxx': 'Nog geen berichten',
  '_xx._sxxx': 'Berichten vernieuwen',
  '_xx._sxcg': 'Succesvol vernieuwd',

  '_fx._fxhy': 'Delen met vrienden',
  '_fx._smfx': 'Scan QR-code om met vrienden te delen',
  '_fx._jlsm': 'Beloningsbeschrijving',
  '_fx._jlsm1': '1. Direct uitgenodigde vrienden (Niveau 1) geven u {a}% van hun inkomsten.',
  '_fx._jlsm2': '2. Vrienden uitgenodigd door uw Niveau 1 vrienden (Niveau 2) geven u {a}% van hun inkomsten.',
  '_fx._jlsm3': '3. Vrienden uitgenodigd door uw Niveau 2 vrienden (Niveau 3) geven u {a}% van hun inkomsten.',
  '_fx._fzlj': 'Link kopiëren',

  '_bzzx._bzzx': 'Helpcentrum',
  '_bzzx._rhzczh': 'Account aanmaken',
  '_bzzx._zclc': 'Registratieproces',
  '_bzzx._rhzcxyh': 'Hoe account aan te maken?',
  '_bzzx._rhzcxyh1': 'Klik op "Registreren", voer e-mailadres in, stel wachtwoord in en voltooi e-mailverificatie.',
  '_bzzx._rhcz': 'Hoe op te waarderen?',
  '_bzzx._rhcz1': 'Opwaarderingsproces',
  '_bzzx._rhcz2': 'Gedetailleerde instructies',
  '_bzzx._rhcz3': 'Klik Mijn Portemonnee, Storten, selecteer cryptocurrency en stuur naar provided adres.',

  '_bzzx._rhjsdj': "Korte drama's ontgrendelen",
  '_bzzx._rhjsdj2': 'Klik om afzonderlijke afleveringen te ontgrendelen.',

  '_bzzx._rhtx': 'Hoe op te nemen',
  '_bzzx._rhtx1': '1. Ga naar Mijn Portemonnee, Opnameadressen, voeg nieuw adres toe.<br>2. Klik Opnemen, selecteer valuta, voer bedrag in en wacht.',

  '_bzzx._qtwt': 'Andere vragen',
  '_bzzx._qtwt1': 'Hoe contact opnemen?',
  '_bzzx._qtwt2': 'Neem contact op via live chat, e-mail of telefoon.',
  '_bzzx._myzdwt': 'Niet gevonden wat u zocht?',
  '_bzzx._khjybbzn': 'Ons team helpt graag verder.',
  '_bzzx._lxkf': 'Contact opnemen',

  '_ggtf._bt1': 'Advertentieplaatsing',
  '_ggtf._splb': 'Videolijst',
  '_ggtf._wcyd': 'Mijn deelname',
  '_ggtf._hdbm': 'Evenementcode',
  '_ggtf._tian': 'Dagen',
  '_ggtf._kssj': 'Starttijd',
  '_ggtf._jssj': 'Eindtijd',
  '_ggtf._ddvp': 'Bereik VIP niveau {a}, gemiddeld {b} deelnames',
  '_ggtf._hdzt': 'Evenementstatus',
  '_ggtf._wks': 'Nog niet begonnen',
  '_ggtf._ycy': 'Deelgenomen',
  '_ggtf._qg': 'Nu kopen',
  '_ggtf._mygdl': 'Geen verdere gegevens',
  '_ggtf._qgrtd': 'Te veel kopers, probeer opnieuw',
  '_ggtf._hdxq': 'Evenementsdetails',
  '_ggtf._hdjs': 'Evenementbeschrijving',
  '_ggtf._cyyq': 'Deelnamevereisten',
  '_ggtf._zdtz': 'Minimale investering',
  '_ggtf._vpdj': 'VIP niveau',
  '_ggtf._rjcy': 'Gemiddelde deelname',
  '_ggtf._gmje': 'Aankoopbedrag',
  '_ggtf._qsrgmje': 'Voer aankoopbedrag in',
  '_ggtf._qx': 'Annuleren',
  '_ggtf._ljcy': 'Nu deelnemen',
  '_ggtf._ssjymm': 'Voer transactiewachtwoord in',
  '_ggtf._qssjymm': 'Voer transactiewachtwoord in',
  '_ggtf._ji': 'Niveau',
  '_ggtf._ci': 'keer',
  '_ggtf._zdgm': 'Minimaal aankoopbedrag',
  '_ggtf._zggm': 'Maximaal aankoopbedrag',
  '_ggtf._zfz': 'Betaling verwerken...',

  '_wdtg._wjl': 'Nog geen deelnames',
  '_wdtg._tzje': 'Investeringbedrag',
  '_wdtg._zsy': 'Totale inkomsten',
  '_wdtg._hdts': 'Evenementsduur',
  '_wdtg._cysj': 'Deelnametijd',
  '_wdtg._qzf': 'Naar betaling',
  '_wdtg._jxz': 'Bezig',
  '_wdtg._djszje': 'Totaal openstaand',
  '_wdtg._gjb': 'Totaal {a} items',
  '_wdtg._djs': 'Openstaand',
  '_wdtg._zrsy': 'Inkomsten gisteren',
  '_wdtg._dbl': 'Video-on-demand weergaven',
  '_wdtg._bfl': 'Aantal weergaven',
  '_wdtg._wdsy': 'Mijn inkomsten',
  '_wdtg._bqffc': 'Auteursrechthouder aandeel',
  '_wdtg._mr0djs': 'Inkomsten gisteren dagelijks om 00:00 verrekend',
  '_wdtg._jrsy': 'Inkomsten vandaag',
  '_wdtg._mygd': 'Geen verdere gegevens',

  '_bqyy._bqyy': 'Auteursrechten samenwerking reservering',
  '_bqyy._qrbq': 'Reservering bevestigen?',
  '_bqyy._qx': 'Annuleren',
  '_bqyy._tjyy': 'Reservering indienen',

  '_bqyy._spsq': 'Video auteursrechten samenwerking',
  '_bqyy._spsy': "Promoot video's samen voor meer verkeer en inkomsten!",
  '_bqyy._ljyy': 'Nu reserveren',
  '_bqyy._sphz': 'Wat is video auteursrechten samenwerking?',
  '_bqyy._sphzsm': 'Samenwerking biedt meer zichtbaarheid voor wederzijds voordeel.',
  '_bqyy._sqhch': 'Voordelen samenwerking',
  '_bqyy._llfz': 'Verkeersondersteuning',
  '_bqyy._llfzsm': 'Vergroot zichtbaarheid en weergaven.',
  '_bqyy._sytg': 'Verhoogde inkomsten',
  '_bqyy._sytgsm': 'Geniet van hogere advertentie-inkomsten.',
  '_bqyy._yxhz': 'Prioritaire samenwerking',
  '_bqyy._yxhzsm': 'Neem prioritair deel aan officiële evenementen.',
  '_bqyy._yytj': 'Reserveringsvoorwaarden',
  '_bqyy._sptg': 'Videopromotie vereisten',
  '_bqyy._sptgsm': 'Neem deel aan minimaal 1 videopromotie.',
  '_bqyy._yysm': 'Ons team neemt binnen 3 dagen contact op.',

  '_ybp._wdsy': 'Mijn inkomsten',
  '_ybp._dqye': 'Huidig saldo',
  '_ybp._jr': 'Vandaag',
  '_ybp._jrzsy': 'Totale inkomsten vandaag',
  '_ybp._ljzsy': 'Cumulatieve totale inkomsten',
  '_ybp._tgfh': 'Promotiedividenden',
  '_ybp._ljsy': 'Cumulatieve inkomsten',
  '_ybp._bqsy': 'Auteursrechteninkomsten',
  '_ybp._yqfh': 'Uitnodigingsdividenden',
  '_ybp._mrsy': 'Dagelijkse inkomsten',
  '_ybp._tgsy': 'Promotie-inkomsten',

  '_tjdz._tjxd': 'Nieuw adres toevoegen',
  '_tjdz._xzbz': 'Selecteer valuta',
  '_tjdz._qbdz': 'Portemonnee adres',
  '_tjdz._srdz': 'Voer portemonnee adres in',
  '_tjdz._qx': 'Annuleren',
  '_tjdz._bc': 'Opslaan',

  '_sz._smrz': 'Identiteitsverificatie',
  '_sz._rzlx': 'Verificatietype',
  '_sz._sfzzm': 'ID-kaart voorzijde',
  '_sz._sfzfm': 'ID-kaart achterzijde',
  '_sz._zsxm': 'Echte naam',
  '_sz._qsrzsxm': 'Voer echte naam in',
  '_sz._sfzhm': 'ID-kaartnummer',
  '_sz._qsrsfzhm': 'Voer ID-kaartnummer in',
  '_sz._yyzz': 'Bedrijfslicentie',
  '_sz._qymc': 'Bedrijfsnaam',
  '_sz._yyzzh': 'Licentienummer',
  '_sz._qsrqymc': 'Voer bedrijfsnaam in',
  '_sz._qsryyzzh': 'Voer licentienummer in',
  '_sz._qx': 'Annuleren',
  '_sz._tjrz': 'Verificatie indienen',
  '_sz._zt': 'Status',
  '_sz._gr': 'Individueel',
  '_sz._qy': 'Bedrijf',
  '_sz._shz': 'In behandeling',
  '_sz._ytg': 'Goedgekeurd',
  '_sz._ybh': 'Afgewezen',

  '_mm._xgmm': 'Wachtwoord wijzigen',
  '_mm._dqxg': 'Wijzig regelmatig wachtwoord',
  '_mm._dqmm': 'Huidig wachtwoord',
  '_mm._xmm': 'Nieuw wachtwoord',
  '_mm._qrxmm': 'Bevestig nieuw wachtwoord',
  '_mm._qx': 'Annuleren',
  '_mm._qrxg': 'Wijziging bevestigen',

  '_jymm._xgjymm': 'Transactiewachtwoord wijzigen',

  '_szzx._sz': 'Instellingen',
  '_szzx._yrz': 'Geverifieerd',
  '_szzx._wrz': 'Niet geverifieerd',
  '_szzx._jymm': 'Transactiewachtwoord',
  '_szzx._szjymm': 'Transactiewachtwoord instellen/wijzigen',
  '_szzx._tcdl': 'Uitloggen',
  '_szzx._qdtcdl': 'Weet u zeker dat u wilt uitloggen?',
  '_szzx._qrtc': 'Uitloggen bevestigen',
  '_szzx._qx': 'Annuleren',

  '_yj._gy': 'Over ons',

  '_yj._lxwm': 'Contact',

  '_yj._yszc': 'Privacybeleid',

  '_yj._yhxy': 'Gebruikersovereenkomst',

  '_cd._gszz': 'Kwalificaties van het bedrijf',

  '_cd._wmyy': 'We beschikken over alle branchekwalificaties en certificeringen en bieden gebruikers legale, veilige en hoogwaardige videodiensten',

  '_cd._yyzz': 'Geldig bewijs van de legale bedrijfsvoering, waaruit onze formele registratiegegevens en bedrijfsactiviteiten blijken',

  '_cd._yyzz2': 'Een legaal verkregen, door het bedrijf gecertificeerde bedrijfslicentie, die de legaliteit en naleving van het platform garandeert',

  '_bz._lxkf': 'Klik hieronder om contact op te nemen met de klantenservice of neem contact met ons op via het e-mailadres of de hotline van de klantenservice',

  '_sz._bjtx': 'Bewerken',

  '_sz._bjxx': 'Bericht bewerken',

  '_sz._tx': 'Avatar',

  '_sz._bcun': 'Opslaan',

  '_db._zskf': 'Contact opnemen met support',
  '_db._zsry': 'Toegewezen agent',
  '_db._wdq': 'Ongelezen',
  '_db._ydq': 'Gelezen',

  '_sc._sctp': 'Afbeelding uploaden',
  '_sc._xztp': 'Afbeelding kiezen',
  '_sc._fstp': 'Afbeelding verzenden',
  '_sc._qx': 'Annuleren',
  '_sc._hd': 'Oké',

  '_zcyl._zcbt': 'Registratiebonus',
  '_zcyl._djdkhb': 'Tik om rode envelop te openen',
  '_zcyl._zclj': 'Registratiebeloning',
  '_zcyl._hmyzh': 'Nog geen account?',
  '_zcyl._qzc': 'Registreren',
  '_zcyl._qxdjhb': 'Claim eerst je beloning',
  '_zcyl._qwzc': 'Naar registratie',
  '_zcyl._hbysy': 'Beloning al gebruikt',

  '_ggtg._qhz': 'Ga naar Overboeking',
  '_ggtg._dqye': 'Huidig Saldo',
  '_ggtg._qcz': 'Ga naar Storten',
  '_ggtg._hzje': 'Overboekingsbedrag',
  '_ggtg._ljhz': 'Direct Overboeken',
  '_ggtg._yebz': 'Onvoldoende Saldo',

  '_sq._bhbt': 'Afgewezen',

  '_sq._bhyy': 'Reden voor afwijzing',

  '_xx._ntq': '{n} dagen geleden',

  '_xx._nxsq': '{n} uur geleden',

  '_xx._nfzq': '{n} minuten geleden',

  '_xx._nggq': 'Zojuist',

  '_xx._djckgd': 'Klik om meer te bekijken',

  '_ct._zt': 'Status',

  '_ct._ljz': 'Verbinden',

  '_ct._ylj': 'Verbonden',

  '_ct._ltlieb': 'Chatlijst',

  '_ct._bnhzj': 'Kan niet met mezelf chatten',

  '_ct._cylb': 'Ledenlijst',

  '_hb._fhb': 'Rode envelop',

  '_hb._dqye': 'Huidig ​​saldo',

  '_hb._fsd': 'Verzonden naar',

  '_hb._hbje': 'Bedrag rode envelop',

  '_hb._qshuru': 'Voer het bedrag van de rode envelop in',

  '_hb._ljfs': 'Nu verzenden',

  '_hb._hbz': "Rode envelop'Zegen",
  '_hb._qshuruzhu': 'Voer uw zegen in',

  '_sp._cuow': 'Afleveringen 1-10 moeten worden ontgrendeld voordat je ze kunt bekijken',

  '_bq._tzzq': 'Investeringsperiode',

  '_bq._zrsy': 'Winst van gisteren',

  '_bq._bqtz': 'Investering in auteursrecht',

  '_bq._tzdj': 'Investeringsbedrag',

  '_bq._zfjz': 'Betaling dient binnen 24 uur te geschieden, anders wordt dit beschouwd als een kwijtschelding!',

  '_bq._qzf': 'Betaling uitvoeren',

  '_bq.jz': 'Deadline',

  '_bq._ljzf': 'Nu betalen',

  '_bq._sqbz': 'Aanvullingen (optioneel)',

  '_bq._sqbzsm': 'Voer aanvullingen in',

  '_bq._zzsqz': 'Auteursrechtaanvraag in voortgang, in afwachting van beoordeling...',

  '_app._xz': 'Download de ReelShortBiz-applicatie',

  '_app._smerm': 'Scan de QR-code om te downloaden',

  '_app._xzbt': 'Downloaden',

  '_m._yhzz': 'Bankoverschrijving',
  '_m._yhxx': 'Bankinformatie',
  '_m._yhmz': 'Banknaam',
  '_m._yhdz': 'Bankadres',
  '_m._yhmc': 'Naam',
  '_m._yhzh': 'Rekening',
  '_m._yhlx': 'Type',
  '_m._yhly': 'Routing',
  '_m._yhdm': 'Code',
  '_m._yhbz': 'Notitie',
  '_m._fzxx': 'Info kopiëren',

  '_m._zts': 'Tips',

  '_m._zyd1': '1. Controleer zorgvuldig de naam, het rekeningnummer en de bankcode van de ontvanger bij het overmaken van geld. Elke fout kan leiden tot het verlies van de overmaking.',

  '_m._zyd2': "2. Het is aan te raden 'Afzender draagt ​​alle kosten' te selecteren om te voorkomen dat er onvoldoende saldo is vanwege inhoudingen door tussenliggende banken.",

  '_m._zyd3': '3. Overmakingen duren meestal 1-3 werkdagen. Wees geduldig. Neem bij vragen contact op met de klantenservice.',

  '_m._zyd4': '4. Neem bij overige vragen contact op met de klantenservice.',

  '_m._jyh': 'Transactienummer',

  '_m._jyje': 'Bedrag',

  '_sp._dbye': 'VOD-saldo',
  '_sp.hzye': 'Overdracht',
  '_sp._txje': 'Overdrachtbedrag',
  '_sp._qsrtxje': 'Voer het overdrachtbedrag in',
  '_sp._ljhz': 'Nu overdragen',
  '_sp._yebz': 'Onvoldoende saldo',
  '_sp._qshuru': 'Voer het juiste overdrachtbedrag in',
  '_sp._fanh': 'Terug',

  '_sp._tliu': 'Advertentieplaatsing',
  '_sp._xzgj': 'Selecteer land',
  '_sp._cdcw': 'Videocodeerfout',
  '_ggtf._hot': 'Populair',
  '_tl._tlsj': 'Advertentietijd',
  '_tl._xzxb': 'Selecteer geslacht',
  '_tl._nan': 'Man',
  '_tl._nv': 'Vrouw',
  '_tl._hunhe': 'Gemengd',
  '_tl._xznl': 'Selecteer leeftijd',
  '_sp._us': 'Verenigde Staten',
  '_sp._en': 'Verenigd Koninkrijk',
  '_sp._jp': 'Japan',
  '_sp._fr': 'Frankrijk',
  '_sp._kr': 'Zuid-Korea',
  '_sp._de': 'Duitsland',
  '_sp._id': 'India',
  '_sp._in': 'Indonesië',
  '_sp._au': 'Australië',
  '_sp._es': 'Spanje',
  '_sp._my': 'Maleisië',
  '_sp._cn': 'China',
  '_ggtf._fanhui': 'Terug',
  '_ggtf._jymmts': 'Bevestig het transactiebedrag en voer uw wachtwoord in',
  '_wdtg._wjl_desc': 'U heeft nog niet deelgenomen aan advertentiecampagnes',
  '_wd._jxz': 'Bezig',
  '_wd._djs': 'In afwachting van afrekening',
  '_wd._ywc': 'Voltooid',
  '_wd._jz': 'Dringend',
  '_wd._hz': 'Overschrijving',

  '_tl._tlfbqk': 'Verdeling van advertentie-uitgaven',
  '_tl._tlfbqk_desc': 'Dagen 1-5: 5% (Koude startfase), Dagen 6-10: 20% (Inhoudsvalidatiefase), Dagen 11-15: 40% (IP-opbouwfase), Dagen 16-20: 35% (Korte serie-matrixfase)',

  '_nhz._sm': 'Na de overboeking wordt het bedrag overgemaakt naar de videoportemonnee om video-inhoud te ontgrendelen',
  '_nhz._zhzz': 'Overboeken...',
  '_nhz._zzcg': 'Overboeking geslaagd',
  '_nhz._zhzsb': 'Overboeking mislukt, probeer opnieuw',
  '_m._fzcg': 'Succesvol gekopieerd',
  '_m._fzsb': 'Kopiëren mislukt, kopieer handmatig',
  '_m._zwfzxx': 'Geen informatie om te kopiëren',
  '_tx._qb': 'Alle',
  'activity.detail': 'Activiteitsdetails',
  'activity.noDesc': 'Geen activiteitsbeschrijving',
  'activity.desc': 'Activiteitsbeschrijving',
  'activity.requirements': 'Deelnamevoorwaarden',
  'activity.minInvest': 'Minimale investering',
  'activity.vipLevel': 'VIP-niveau',
  'activity.avgParticipation': 'Gemiddelde deelname',
  'activity.avgParticipationDesc': 'keer',
  'activity.country': 'Selecteer land',
  'activity.deliveryTime': 'Advertentietijd',
  'activity.deliveryTimeDesc': 'dagen',
  'activity.gender': 'Selecteer geslacht',
  'activity.male': 'Mannelijk',
  'activity.female': 'Vrouwelijk',
  'activity.mixed': 'Gemengd',
  'activity.age': 'Selecteer leeftijd',
  'activity.amount': 'Aankoopbedrag',
  'activity.back': 'Terug',
  'activity.join': 'Nu deelnemen',
  emptyData: 'Geen gegevens',
  emptyDataDesc: 'Geen deelnemende advertentiecampagnes',
  completedtlement: 'Verlopen',
  preheat: 'Voorverwarmen',
  progress: 'Bezig',
  settlement: 'In afwachting van afwikkeling',
  transfered: 'Overgemaakt',
  completed: 'Voltooid',
  activityCode: 'Activiteitscode',
  touzAmount: 'Investeringsbedrag',
  activityDays: 'Activiteitsdagen',
  joinTime: 'Deelnametijd',
  playSource: 'Distributie van afspeelbronnen',
  allPlatforms: 'Alle platforms',
  other: 'Anders',
  totalPlayNum: 'Totaal aantal afspeelbeurten',
  incomeSummary: 'Inkomstenoverzicht',
  totalPay: 'Betaalde auteursrechtkosten',
  totalIncome: 'Totale inkomsten',
  copyrightRatio: 'Aandeel van rechthebbende',
  promotionIncome: 'Promotie-inkomsten',
  copyrightIncome: 'Auteursrechtaandeel',
  playNum: 'Afspeelbeurten',
  buyNum: 'On-demand afspeelbeurten',
  incomeRate: 'Verdeelratio',
  yjIncome: 'Geschatte inkomsten',
  paid: 'Betaald',
  timeout: 'Time-out',
  transfer: 'Nu overmaken',
  loading: 'Laden...',
  loadMore: 'Meer laden',
  noMore: 'Niet meer',
  nightTime: 'Nachtperiode',
  morningTime: 'Ochtendperiode',
  afternoonTime: 'Middagperiode',
  eveningTime: 'Avondperiode',
  '_h._tc': 'Uitloggen',
  periodPayment: 'Periodebetaling',
  periodPaymentDesc: 'Afwikkeling vindt 4 keer per dag plaats in 4 perioden, u kunt auteursrechtkosten per periode betalen',

  day: 'dag',
  '_dl._hy': 'Welkom terug',
  '_dl._cj': 'Account aanmaken',
  '_dl._zmm': 'Wachtwoord resetten',
  '_dl._hyDesc': 'Log in op je account om verder te gaan met het ontdekken van geweldige content',
  '_dl._cjDesc': 'Word lid van ReelShortBiz en begin aan je spannende reis',
  '_dl._zmmDesc': 'Voer je e-mailadres in en we sturen een verificatiecode om te resetten',
  '_dl._hlgqsp': 'Uitgebreide HD-film- en videobronnen',
  '_dl._gxhty': 'Gepersonaliseerde aanbevelingsalgoritmen',
  '_dl._ffddsp': "Rijke korte video's",
  '_dl._dlzh': 'Inloggen',
  '_dl._sdndyx': 'Voer je e-mail en wachtwoord in om door te gaan',
  '_dl._email': 'E-mailadres',
  '_dl._qsryx': 'Voer je e-mailadres in',
  '_dl._dlmm': 'Wachtwoord',
  '_dl._qsrmm': 'Voer je wachtwoord in',
  '_dl._wjmm': 'Wachtwoord vergeten?',
  '_dl._immdl': 'Nu inloggen',
  '_dl._hmyzh2': 'Heb je geen account?',
  '_dl._ljzc2': 'Nu registreren',
  '_dl._cjzh': 'Account aanmaken',
  '_dl._jswmd': 'Word lid van ReelShortBiz en begin aan je spannende reis',
  '_zh._qszmm': 'Stel je wachtwoord in',
  '_zh._qrmm': 'Bevestig wachtwoord',
  '_zh._qmm': 'Voer het wachtwoord opnieuw in',
  '_zc._yqm': 'Uitnodigingscode',
  '_zc._sryqm': 'Voer de uitnodigingscode in',
  '_dl._yzm': 'Verificatiecode',
  '_dl._qsryzm': 'Voer de verificatiecode in',
  '_dl._yjyzh': 'Heb je al een account?',
  '_dl._zcbsty2': 'Door te registreren ga je akkoord met',
  '_dl._zcbstyDesc': 'Privacybeleid',
  '_dl._newmm': 'Nieuw wachtwoord',
  '_dl._qszxmm': 'Stel een nieuw wachtwoord in',
  '_dl._qrmm': 'Bevestig wachtwoord',
  '_dl._qzcsrmm': 'Voer het nieuwe wachtwoord opnieuw in',
  '_dl._czmm': 'Wachtwoord resetten',
  '_dl._xqlmm': 'Wachtwoord herinnerd?',
  '_dl._fhdl': 'Terug naar inloggen',
  '_dl._srdllmmbyz': 'Wachtwoorden komen niet overeen',
  '_dl._czcg': 'Wachtwoord succesvol gereset',
  '_h._zc': 'Registreren',
  // '_ybp._wdsy': 'Mijn inkomsten',
  '_ybp._jrsy': 'Inkomsten vandaag',
  '_ybp._jztr': 'Vergeleken met gisteren',
  '_ybp._bfl': 'Weergaven',
  '_ybp._dbl': 'Aanvragen',
  '_ybp._syqs': 'Inkomsten trend',
  // '_ybp._jr': 'Vandaag',
  '_ybp._t': 'dag',
  // '_ybp._dqye': 'Saldo',
  '_ybp._djs': 'In afwachting van afrekening',
  '_ybp._zhl': 'Conversiepercentage',
  '_ybp._sjgl': 'Gegevensoverzicht',
  '_ybp._zrsy': 'Inkomsten gisteren',
  '_ybp._bysy': 'Inkomsten deze maand',
  '_ybp._yysj': 'Operationele gegevens',
  '_ybp._zr': 'Gisteren',
  '_ybp._zjfrs': 'Totaal betalende gebruikers',
  '_ybp._mtdqje': 'Morgen te ontvangen bedrag',
  '_ybp._jsy': 'Nettowinst',
  '_ybp._bqfy': 'Betalingsplan voor auteursrechten',
  '_ybp._yzf': 'Betaald',
  '_ybp._qzf': 'Ga naar betalen',
  '_ybp._bqfyts': 'Na betaling van auteursrechten worden je inkomsten en rechten geprioriteerd',
  '_ybp._syjl': 'Inkomsten geschiedenis',
  '_ybp._ckgd': 'Bekijk meer',
  '_ybp._ssdt': 'Live updates',
  '_ybp._bzzx': 'Helpcentrum',
  '_ybp._lxkf': 'Neem contact op met ondersteuning',
  '_ybp._zrxz': 'Inkomsten gisteren',
  '_ybp._zdsy': 'Totale inkomsten',
  '_ybp._qygy': 'Vorige maand',
  '_ybp._jsjl': 'Afrekeningsgeschiedenis',
  '_ybp._hzjl': 'Overboekingsgeschiedenis',
  '_ybp._jfzq': 'minuten geleden',
  '_ybp._fzq': 'uur geleden',
  '_ybp._djs_mt': 'Afwikkelingsbedrag morgen',
  '_yj._rule': 'Platformregels',

  '_bq._jjks': 'Nu starten',
  '_bq._jxz': 'Bezig',
  '_bq._jks': 'Tijd tot start',
  '_bq._jjs': 'Tijd tot einde',
  '_bq._t': 'd',
  '_bq._h': 'u',
  '_bq._m': 'm',
  '_bq._s': 's',
  '_bq._kssj': 'Starttijd',
  '_bq._jssj': 'Eindtijd',
  '_bqq._tzdj': 'Stukprijs',
  '_bqq._hdts': 'Activiteitsdagen',
  '_bqq._vip': 'VIP-niveau',
  '_bqq._rjcy': 'Gemiddelde deelname',
  '_bqq._cs': 'keer',
  '_bqq._ysjd': 'Verkoopvoortgang',
  '_bqq._ljqg': 'Nu kopen',
  '_bqq._zbkqg': 'Momenteel niet beschikbaar',
  '_bqq._jzz': 'Laden',
  '_bqq._jzgd': 'Meer laden',
  '_bqq._wz': 'Geen meer',

  '_sp._gdsj': 'Totaal {n} afleveringen',
  '_sy._jl': 'In afwachting van vereffening',
  '_ybp._zsy': 'Totale omzet',
  '_ybp._djsjl': 'In afwachting van vereffening',
  '_ybp._bqbm': 'Code',
  '_ybp._je': 'Bedrag',
  '_ybp._sj': 'Tijd',
  '_sy._djs': 'In afwachting',
  '_sy._yjs': 'Vereffend',
  '_sy._gdstjl': 'Totaal {n} records',
  '_sy._gjd': 'Totaal {n}',

  '_sp.tgdy':'Het bedrag mag niet lager zijn dan {a}',
  '_sp.tggy':'Het bedrag mag niet hoger zijn dan {a}',

  '_tg._zdyje': 'Aangepast bedrag'
}
